import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  useRef,
  useReducer,
} from "react";
import {
  useTable,
  useGlobalFilter,
  useFilters,
  usePagination,
} from "react-table";
import { Link, useHistory } from "react-router-dom";
import { COLUMNS_LIQ } from "./Columns";
import { GlobalFilter } from "./GlobalFilter";
import "./filtering.css";
import { getAllLiquidaciones, liquidarliquidacion } from "../../api/marcacionApi";
import { getUserCredentials } from "../../api/usuarioApi";
import { getAdminById } from "../../api/AdminApi";
import Gastos from "./sesiones/Gastos";
import { TiMinus, TiPlus } from "react-icons/ti";
import { FiEdit } from "react-icons/fi";
import Proveedores from "./liquidacion/Proveedores";
import Anticipos from "./liquidacion/Anticipos";
import ModalLiquidar from "./liquidacion/ModalLiquidar";
import Swal from "sweetalert2";

// Utilidad para mostrar SweetAlert con loading
const withLoadingSwal = async (fn) => {
  Swal.fire({
    title: "Cargando",
    didOpen: () => Swal.showLoading(),
    allowOutsideClick: false,
  });
  try {
    await fn();
  } catch (err) {
    Swal.fire({ icon: "error", title: "Error", text: `${err}` });
    throw err;
  }
};

// Formatea el monto con puntos como miles y coma para decimales
const formatMonto = (value) => {
  if (value === "" || value === null || value === undefined) return "";
  let cleanValue = value.toString().replace(/\./g, "").replace(",", ".");
  let number = Number(cleanValue);
  if (isNaN(number)) return value;
  let [int, dec] = Math.abs(number)
    .toFixed(2)
    .split(".");
  let intWithDots = int.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  let result =
    (number < 0 ? "-" : "") +
    intWithDots +
    (dec && dec !== "00" ? "," + dec : "");
  return result;
};

// Reducer para controlar el estado del modal y el registro seleccionado
const initialModalState = {
  isShow: false,
  ficha: null,
};
function modalReducer(state, action) {
  switch (action.type) {
    case "START":
      return { isShow: true, ficha: action.payload };
    case "END":
      return { isShow: false, ficha: null };
    default:
      return state;
  }
}

export const Liquidaciones = () => {
  const columns = useMemo(() => COLUMNS_LIQ, []);
  const [data, setData] = useState([]);
  const [showGastos, setShowGastos] = useState(false);
  const [loading, setLoading] = useState(true);
  const [hasPermission, setHasPermission] = useState(undefined);
  const [showTotal, setShowTotal] = useState(false);
  const history = useHistory();
  const tableRef = useRef(null);
  const [showProveedores, setShowProveedores] = useState(false);
  const [showAnticipos, setShowAnticipos] = useState(false);

  // Modal State
  const [reducer, dispatchReducer] = useReducer(modalReducer, initialModalState);

  // Permisos: solo usuarios con cierres habilitados pueden ver la página
  useEffect(() => {
    const checkPermissionAndLoad = async () => {
      setLoading(true);
      try {
        const resultUser = await getUserCredentials();
        const USERDATA = await getAdminById(resultUser.IdUsuario);
        if (!USERDATA || USERDATA[0]?.cierres === "false") {
          setHasPermission(false);
          setLoading(false);
          return;
        }
        setHasPermission(true);

        // Permiso para mostrar el campo Total
        if (
          USERDATA[0]?.IdTipoUsuario === "0" ||
          USERDATA[0]?.IdTipoUsuario === "2"
        ) {
          setShowTotal(true);
        } else {
          setShowTotal(false);
        }
      } catch (e) {
        setHasPermission(false);
        setShowTotal(false);
      } finally {
        setLoading(false);
      }
    };
    checkPermissionAndLoad();
  }, [history]);

  // Cargar datos solo si tiene permiso
  const assigmentValue = useCallback(async () => {
    try {
      setLoading(true);
      const result = await getAllLiquidaciones();
      setData([...result]);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  }, []);

  useEffect(() => {
    if (hasPermission === true) {
      assigmentValue();
    }
  }, [hasPermission, assigmentValue]);

  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 10, pageIndex: 0 },
    },
    useFilters,
    useGlobalFilter,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    page,
    gotoPage,
    pageCount,
    pageOptions,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setGlobalFilter,
  } = tableInstance;

  const { globalFilter, pageIndex } = state;

  // Función para el callback de liquidación
  const Liquidar = async (newData) => {
    dispatchReducer({ type: "END" });
    await withLoadingSwal(async () => {
      const id = reducer.ficha.id;
      const result = await liquidarliquidacion({ ...newData, idliquidacion: id });

      if (result) {
        setData((oldData) =>
          oldData.map((row) => {
            if (row.id === id) {
              // Log para comparar
              console.log("Row viejo:", row);
              console.log("Row nuevo:", { ...row, ...newData });
              return { ...row, ...newData };
            }
            return row;
          })
        );
        Swal.fire({
          title: "Liquidación actualizada",
          icon: "success",
          timer: 1600,
          showConfirmButton: false,
        });
      }
    });
  };

  if (loading) {
    return (
      <div style={{
        minHeight: "60vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        zIndex: 2
      }}>
        <div style={{
          width: 38,
          height: 38,
          border: "4px solid #ddd",
          borderTop: "4px solid #1569c9ff",
          borderRadius: "50%",
          animation: "spin 1s linear infinite"
        }} />
        <span style={{ marginLeft: 14, color: "#444", fontSize: 18 }}>Cargando...</span>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg);}
              100% { transform: rotate(360deg);}
            }
          `}
        </style>
      </div>
    );
  }

  if (hasPermission === false) {
    return (
      <div style={{ textAlign: "center", marginTop: 50 }}>
        <h3>No tiene permisos para ver esta información.</h3>
      </div>
    );
  }
  if (hasPermission !== true) {
    return null;
  }

  return (
    <div className="card">
      <div className="card-header">
        <h4 className="card-title">Cierres</h4>
      </div>
      <div className="card-body">
        <div className="col-xl-12 col-lg-12 col-xxl-12 col-sm-12 collapsible-header" onClick={() => setShowGastos(!showGastos)}>
          <h4 className="card-title mb-0">
            Gastos{" "}
            <button
              type="button"
              className="btn btn-light btn-sm"
              onClick={(event) => { event.stopPropagation(); setShowGastos(!showGastos); }}
              style={{ border: "none", background: "none", boxShadow: "none" }}
              aria-label={showGastos ? "Ocultar gastos" : "Mostrar gastos"}
            >
              {showGastos ? <TiMinus size={24} /> : <TiPlus size={24} />}
            </button>
          </h4>
        </div>
        {showGastos && (
          <Gastos metodo="administrativo" />
        )}
        <div className="col-xl-12 col-lg-12 col-xxl-12 col-sm-12 mt-4 collapsible-header" onClick={() => setShowProveedores(!showProveedores)}>
          <h4 className="card-title mb-0">
            Proveedores{" "}
            <button
              type="button"
              className="btn btn-light btn-sm"
              onClick={(event) => { event.stopPropagation(); setShowProveedores(!showProveedores); }}
              style={{ border: "none", background: "none", boxShadow: "none" }}
              aria-label={showProveedores ? "Ocultar proveedores" : "Mostrar proveedores"}
            >
              {showProveedores ? <TiMinus size={24} /> : <TiPlus size={24} />}
            </button>
          </h4>
        </div>
        {showProveedores && (
          <Proveedores metodo="administrativo" />
        )}

        <div className="col-xl-12 col-lg-12 col-xxl-12 col-sm-12 mt-4 collapsible-header" onClick={() => setShowAnticipos(!showAnticipos)}>
          <h4 className="card-title mb-0">
            Anticipos{" "}
            <button
              type="button"
              className="btn btn-light btn-sm"
              onClick={(event) => { event.stopPropagation(); setShowAnticipos(!showAnticipos); }}
              style={{ border: "none", background: "none", boxShadow: "none" }}
              aria-label={showAnticipos ? "Ocultar anticipos" : "Mostrar anticipos"}
            >
              {showAnticipos ? <TiMinus size={24} /> : <TiPlus size={24} />}
            </button>
          </h4>
        </div>
        {showAnticipos && (
          <Anticipos soloDisponibles />
        )}

        <div className="table-responsive">
          <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
          <table
            {...getTableProps()}
            className="table dataTable display"
            ref={tableRef}
          >
            <thead>
              {headerGroups.map((headerGroup, index1) => (
                <tr {...headerGroup.getHeaderGroupProps()} key={index1}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()} key={column.id}>
                      {column.render("Header")}
                      {column.canFilter ? column.render("Filter") : null}
                    </th>
                  ))}
                  {showTotal && <th>Tarifa</th>}
                   {showTotal && <th>Honorario</th>}
                  <th style={{ textAlign: "center" }}>Opciones</th>
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row, index2) => {
                prepareRow(row);
                const estadoActual = (row.original.estado || row.original.Estado || "").toLowerCase();
                return (
                  <tr {...row.getRowProps()} key={index2}>
                    {row.cells.map((cell, index3) => (
                      <td
                        {...cell.getCellProps()}
                        key={index3}
                        style={{ padding: "10px" }}
                      >
                        {cell.column.id === "monto"
                          ? formatMonto(cell.value)
                          : (
                            <Link
                              to={{
                                pathname: "/fichaliquidacion/" + row.values.id,
                                state: {
                                  id: row.values.id,
                                  nombrepaciente: row.values.Nombre,
                                },
                              }}
                            >
                              {cell.render("Cell")}
                            </Link>
                          )
                        }
                      </td>
                    ))}
                    {showTotal && (
                      <td>
                        {formatMonto(row.original.totalLiquidacionTarifa)}
                      </td>
                    )}
                        {showTotal && (
                      <td>
                        {formatMonto(row.original.totalLiquidacionHonorario)}
                      </td>
                    )}
                    <td style={{ textAlign: "center" }}>
                      <button
                        type="button"
                        className="btn btn-link btn-sm"
                        title={
                          estadoActual === "liquidado"
                            ? "No se puede editar cuando está liquidado"
                            : "Cambiar Estado"
                        }
                        disabled={estadoActual === "liquidado"}
                        onClick={() => {
                          if (estadoActual !== "liquidado") {
                            dispatchReducer({
                              type: "START",
                              payload: row.original,
                            });
                          }
                        }}
                        style={{
                          padding: 0,
                          margin: 0,
                          color: estadoActual === "liquidado" ? "#ccc" : "",
                          cursor: estadoActual === "liquidado" ? "not-allowed" : "pointer"
                        }}
                      >
                        <FiEdit size={22} />
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div className="d-flex justify-content-between mt-2 align-items-center">
            <span>
              Pagina{" "}
              <strong>
                {pageIndex + 1} de {pageOptions.length}
              </strong>
            </span>
            <span className="table-index">
              Ir a la pagina:{" "}
              <input
                type="number"
                className="ml-2"
                defaultValue={pageIndex + 1}
                min={1}
                max={pageOptions.length}
                onChange={(e) => {
                  const pageNumber = e.target.value
                    ? Number(e.target.value) - 1
                    : 0;
                  gotoPage(pageNumber);
                }}
                style={{ width: "70px" }}
              />
            </span>
          </div>
          <div className="text-center mb-3">
            <div className="filter-pagination mt-3">
              <button
                className="previous-button"
                onClick={() => gotoPage(0)}
                disabled={!canPreviousPage}
              >
                {"<<"}
              </button>
              <button
                className="previous-button"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
              >
                Anterior
              </button>
              <button
                className="next-button"
                onClick={() => nextPage()}
                disabled={!canNextPage}
              >
                Siguiente
              </button>
              <button
                className="next-button"
                onClick={() => gotoPage(pageCount - 1)}
                disabled={!canNextPage}
              >
                {">>"}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* MODAL */}
      {reducer.isShow && (
        <ModalLiquidar
          estado={reducer.isShow}
          onCloseModal={() => dispatchReducer({ type: "END" })}
          onReturnValue={Liquidar}
          estadoliquidacion={reducer.ficha?.estado || reducer.ficha?.Estado || "CIERRE"}
          datos={{
            estado: reducer.ficha?.estado || reducer.ficha?.Estado || "CIERRE",
            facturanumero: reducer.ficha?.facturanumero || "",
            montoliquidado: reducer.ficha?.montoliquidado || "",
            obs: reducer.ficha?.obs2 || "",
            fechaordenpago: reducer.ficha?.fechaordenpago || "",
          }}
        />
      )}
    </div>
  );
};

export default Liquidaciones;
